export default __webpack_public_path__ + "static/media/joseGarcia.37dabcb9.jpg";